import { render, staticRenderFns } from "./sortingform.vue?vue&type=template&id=5717fcd9&scoped=true"
import script from "./sortingform.vue?vue&type=script&lang=js"
export * from "./sortingform.vue?vue&type=script&lang=js"
import style0 from "./sortingform.vue?vue&type=style&index=0&id=5717fcd9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5717fcd9",
  null
  
)

export default component.exports